export const config = {
  ROOT: 'https://atarix.co.il/billy',
  //ROOT: '',
  BILLY_CLASSNAME: 'billy'
};


// WEBPACK FOOTER //
// ./src/constants/config.js